
    <div class="wp-overlay">
      <div class="wp-modal wp-center">
        <div style="display:block;">
          <h4>{{file.name}}</h4>
          <p>File type not able to display in browser. Please Download.</p>
        </div>
        <a class="btn" download [href]="downloadURL" target="_blank">Download Now</a>
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/file.view.unknown.ts.FileViewUnknownComponent.html